var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "data-testid": "empty-floor-plan-state" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "empty-floor-plan-state__card text-center" },
            [
              _c("v-icon", { attrs: { size: "80", color: "grey lighten-1" } }, [
                _vm._v("\n        mdi-floor-plan\n      "),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "mt-4 mb-2" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("empty.title")) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "empty-floor-plan-state__description mb-4" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$mpt(_vm.$t("empty.description"))) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    large: "",
                    "data-testid": "empty-floor-plan-upload-btn",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("upload")
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("\n          mdi-upload\n        "),
                  ]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("empty.upload_button")) +
                      "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }